import React from 'react';
import { Input } from '../../ui/input';
import { Calendar } from 'lucide-react';

export function FixScheduler({ value, onChange }) {
  // CT timezone (America/Chicago)
  const maxDays = 14; // DISPUTE_MAX_FIX_EXTENSION_DAYS
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + maxDays);
  maxDate.setHours(23, 59, 0, 0);

  const formatDateForInput = (date) => {
    if (!date) return '';
    const d = new Date(date);
    // Format as YYYY-MM-DDTHH:MM for datetime-local input
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleChange = (e) => {
    const dateStr = e.target.value;
    if (!dateStr) {
      onChange(null);
      return;
    }

    const selectedDate = new Date(dateStr);
    const now = new Date();

    // Validate within max extension
    if (selectedDate > maxDate) {
      onChange(maxDate.toISOString());
    } else if (selectedDate < now) {
      onChange(now.toISOString());
    } else {
      onChange(selectedDate.toISOString());
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          Fix Due Date (CT Timezone)
        </label>
        <Input
          type="datetime-local"
          value={value ? formatDateForInput(value) : ''}
          onChange={handleChange}
          className="mt-2"
          required
        />
      </div>

      <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-xs text-blue-900">
          <strong>Note:</strong> Auto-approval will remain paused until seller re-delivers.
          Maximum extension: {maxDays} days from now.
        </p>
      </div>

      {value && (
        <div className="text-sm text-gray-600">
          Selected: {new Date(value).toLocaleString('en-US', { timeZone: 'America/Chicago', dateStyle: 'medium', timeStyle: 'short' })} CT
        </div>
      )}
    </div>
  );
}
